import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const FullScreenLoader = ({ open }) => (
  <Backdrop
    sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
    open={open}
  >
    <CircularProgress sx={{ color: "var(--red-color)" }} />
  </Backdrop>
);

export default FullScreenLoader;
